(() => {
  const init = (root) => {
    if (!root || root.dataset.gs2Ready === 'true') return;
    root.dataset.gs2Ready = 'true';
    const menu = root.querySelector('.gs2-menu-toggle');
    menu?.addEventListener('click', () => {
      root.classList.toggle('is-menu-open');
      menu.setAttribute('aria-expanded', root.classList.contains('is-menu-open'));
    });
    root.querySelectorAll('.gs2-thumb').forEach((thumb) => thumb.addEventListener('click', () => {
      const main = root.querySelector('[data-gs2-main-image]');
      if (main) main.src = thumb.dataset.gs2Image;
      root.querySelectorAll('.gs2-thumb').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));
    root.querySelectorAll('.gs2-compare-visual').forEach((visual) => {
      const range = visual.querySelector('.gs2-compare-range');
      const split = visual.querySelector('.gs2-compare-split');
      const handle = visual.querySelector('.gs2-compare-handle');
      const update = () => {
        if (!range || !split || !handle) return;
        split.style.width = range.value + '%';
        handle.style.left = range.value + '%';
      };
      range?.addEventListener('input', update);
      update();
    });
    const storyCarousel = root.querySelector('[data-gs2-story-carousel].is-mobile-carousel');
    const storyPagination = root.querySelector('[data-gs2-story-pagination]');
    if (storyCarousel && storyPagination) {
      const storyCards = Array.from(storyCarousel.querySelectorAll('.gs2-story-card'));
      if (storyCards.length > 1) {
        let activeStory = 0;
        let storyScrollFrame = 0;
        const paginationButtons = storyCards.map((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `Show story ${index + 1}`);
          button.addEventListener('click', () => {
            const offset = storyCards[index].getBoundingClientRect().left - storyCarousel.getBoundingClientRect().left + storyCarousel.scrollLeft;
            storyCarousel.scrollTo({ left: offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
          storyPagination.append(button);
          return button;
        });
        const setActiveStory = (index) => {
          activeStory = index;
          paginationButtons.forEach((button, buttonIndex) => {
            if (buttonIndex === index) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
        };
        const updateActiveStory = () => {
          storyScrollFrame = 0;
          const trackLeft = storyCarousel.getBoundingClientRect().left;
          const nearestIndex = storyCards.reduce((closestIndex, card, index) => {
            const currentDistance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            const closestDistance = Math.abs(storyCards[closestIndex].getBoundingClientRect().left - trackLeft);
            return currentDistance < closestDistance ? index : closestIndex;
          }, 0);
          setActiveStory(nearestIndex);
        };
        storyCarousel.addEventListener('scroll', () => {
          if (!storyScrollFrame) storyScrollFrame = window.requestAnimationFrame(updateActiveStory);
        }, { passive: true });
        setActiveStory(activeStory);
        const storyControls = root.querySelector('.gs2-story-controls');
        storyControls?.querySelector('.gs2-story-prev')?.addEventListener('click', () => {
          paginationButtons[Math.max(0, activeStory - 1)]?.click();
        });
        storyControls?.querySelector('.gs2-story-next')?.addEventListener('click', () => {
          paginationButtons[Math.min(storyCards.length - 1, activeStory + 1)]?.click();
        });
      }
    }
    const compare = root.matches('.gs2-section-compare') ? root : root.querySelector('.gs2-section-compare');
    if (compare) {
      if (window.matchMedia('(max-width: 749px)').matches || navigator.maxTouchPoints > 0) {
        compare.classList.add('is-mobile-scroll-control');
      }
      const cards = compare.querySelector('[data-gs2-compare-cards]');
      const table = compare.querySelector('[data-gs2-compare-table]');
      const control = compare.querySelector('[data-gs2-compare-scroll]');
      if (cards && table && control) {
        let syncing = false;
        const maxScroll = (element) => Math.max(0, element.scrollWidth - element.clientWidth);
        const sync = (source) => {
          if (syncing) return;
          const sourceMax = maxScroll(source);
          const progress = sourceMax ? source.scrollLeft / sourceMax : 0;
          const target = source === cards ? table : cards;
          const targetLeft = progress * maxScroll(target);
          syncing = true;
          if (Math.abs(target.scrollLeft - targetLeft) > 1) target.scrollLeft = targetLeft;
          control.value = String(Math.round(progress * 100));
          window.requestAnimationFrame(() => { syncing = false; });
        };
        cards.addEventListener('scroll', () => sync(cards), { passive: true });
        table.addEventListener('scroll', () => sync(table), { passive: true });
        control.addEventListener('input', () => {
          if (syncing) return;
          const progress = Number(control.value) / 100;
          syncing = true;
          cards.scrollLeft = progress * maxScroll(cards);
          table.scrollLeft = progress * maxScroll(table);
          window.requestAnimationFrame(() => { syncing = false; });
        });
      }
    }
    root.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }));
  };

  document.querySelectorAll('.gs2-page').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector?.('.gs2-page')));
})();
